/** @copyright (c) Viewpost. All Rights Reserved. See LICENSE for more details. */

import React, { useEffect, useState } from 'react';

import useApi from 'api/hooks/useApi';
import acceptVccTerms from 'api/onboarding/acceptVccTerms';

// import LoadingIndicator from 'components/LoadingIndicator';

import Button from 'components/Button';
import HeaderText, { HeaderTextVariants } from 'components/HeaderText';

import Alert from 'components/Alert';


import {
  MailToCustomerSupport
} from 'config/messageLinks';

import TermsScrollWrap from 'containers/TermsScrollWrap';

function AcceptVccTerms({
  isAssistedPay,
  customerCompany,
  onAcceptComplete,

  remitToEmail,

  // expect one or other for landing page vs in-app
  addressBookId,
  secureToken
}) {

  const api = useApi(acceptVccTerms, 'AcceptVccTerms', {
    onComplete: onAcceptComplete
  });

  let [isScrolled, setScrolled] = useState(false);
  let [acceptError, setAcceptError] = useState();

  useEffect(() => {
    if (!acceptError) return;

    if (isScrolled) {
      setAcceptError(null);
    }
  }, [isScrolled]);

  const onAccept = () => {
    if (!isScrolled) {
      setAcceptError('You must scroll to the end of the terms to continue.');
      return;
    }

    api.call({
      secureToken,
      addressBookId
    });
  };

  return (
    <div className="pad-20-x">
      <HeaderText className="pad-12-bottom">
        Review and Accept Payment Terms
      </HeaderText>

      <HeaderText className="pad-12-bottom" variant={HeaderTextVariants.Small}>
        Please review our Payment Terms and accept them below to receive card payments from <strong>
          {customerCompany}
        </strong>.
      </HeaderText>
      <TermsScrollWrap onScrollToEnd={() => setScrolled(true)} />
      {acceptError
        ? (
          <Alert variant="failure">
            {acceptError}
          </Alert>
        )
        : null}

      <br /><br />

      <HeaderText className="pad-12-bottom" variant={HeaderTextVariants.Small}>
        {isAssistedPay
          ? <>
            Viewpost will assist in processing payments based
            on the preferences you discussed with our payment specialist.
          </>
          : null}
        {!isAssistedPay && remitToEmail
          ? <>Payment instructions will be emailed to <strong>{remitToEmail}</strong>.</>
          : null}
      </HeaderText>

      <HeaderText className="pad-12-bottom" variant={HeaderTextVariants.Small}>
        If you have any questions, please contact our {MailToCustomerSupport('support team')}.
      </HeaderText>

      <div className="pad-20-top">
        <Button
          isDisabled={api.isLoading()}
          isProcessing={api.isLoading()}
          style={{ display: 'block' }}
          onClick={onAccept}>
          I have reviewed and accept the Payment Terms
        </Button>
      </div>

    </div>
  );
}

export default AcceptVccTerms;